import React, { Component, createRef } from 'react';

// CSS
import '../Subscriptions/Subscription.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

// Properties
const properties = require('../../properties.json');

class DeviceLimit extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        maxDevicesInput: '',
        saving: false,
        loading: true,
    }

    componentDidMount() {
        document.title = properties.site_name + " | حد الأجهزة";
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        apiFetch("/teachers/me")
            .then(me => {
                this.setState({
                    maxDevicesInput: me.defaultMaxDevices != null ? String(me.defaultMaxDevices) : '',
                    loading: false,
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                console.error('Error:', error);
            });
    }

    save = () => {
        const raw = (this.state.maxDevicesInput || '').trim();
        const maxDevices = raw === '' ? null : parseInt(raw, 10);
        this.setState({ saving: true });
        apiFetch("/students/device-limit-default", { method: "PUT", body: { maxDevices } })
            .then(() => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم حفظ حد الأجهزة الافتراضي' });
            })
            .catch(error => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    render() {
        const { maxDevicesInput, saving, loading } = this.state;

        return (
            <>
                <Header pageName="حد الأجهزة" />
                <Toast ref={this.toast}></Toast>
                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card title="حد الأجهزة/الجلسات لكل حساب">
                                {!loading &&
                                    <div className="p-col-12 p-md-8 p-m-3">
                                        <p>
                                            حدد أقصى عدد من الأجهزة يقدر يشتغل بيها نفس حساب الطالب في نفس الوقت
                                            (بيتفعّل بس مع الفيديوهات المدفوعة اللي بتشتغل على تطبيق الديسك توب).
                                            لو جهاز جديد حاول يدخل بعد الوصول للحد، هيترفض لحد ما طالب يسيب مكانه
                                            أو الدكتور يزود الحد. اتركه فارغًا يعني بلا حد.
                                        </p>
                                        <p>
                                            ممكن كمان تحدد رقم مختلف لطالب معين من صفحة تعديل بياناته، وهيبقى
                                            الرقم بتاعه هو اللي يتطبق بدل الرقم هنا.
                                        </p>
                                        <div className="p-inputgroup p-mb-3">
                                            <InputText
                                                type="number"
                                                min="1"
                                                value={maxDevicesInput}
                                                placeholder="بلا حد"
                                                onChange={(e) => this.setState({ maxDevicesInput: e.target.value })}
                                            />
                                            <Button label={saving ? "جاري الحفظ..." : "حفظ"} disabled={saving} onClick={this.save} />
                                        </div>
                                    </div>
                                }
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default DeviceLimit;
